<template>
  <div id="app" v-loading.fullscreen.lock="loading">
    <el-container class="app-container">
      <el-main>
        <div class="basicInformation">
          <h1>基础信息</h1>
          <el-form :inline="true" class="slForm" ref="slForm" :model="slForm" :rules="rules"
                   label-position="right">
            <el-row>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="collectWay">
                  <template #label>
                    收款方式
                    <el-popover placement="right" width="400" trigger="hover">
                      <h3>请仔细阅读以下说明</h3>
                      <p>如有<span>一次性收款</span>，直接选择“一次性收款并结项”</p>
                      <p>如有<span>分三次及三次以上收款</span>，第一次选择“申请首次收款”，第二次选择“申请尾款”</p>
                      <p>如有<span>分三次及三次以上收款</span>，第一次选择“申请首次收款”，中间付款选择“申请阶段收款”，最后一笔选择“申请尾款”
                      </p>
                      <p><span>据实结算</span>的收款方式仅支持费用类型是会议类，框架服务模式，按场次收款的项目，可多次申请
                      </p>
                      <i class="el-icon-info" slot="reference"></i>
                    </el-popover>
                  </template>
                  <el-select style="width:100%" disabled v-model="slForm.collectWay"
                             placeholder="请选择收款方式" @change="getProjectConfigFun">
                    <el-option v-for="(item,i) in collectWayEnums" :key="i" :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="feeType">
                  <template #label>费用类型</template>
                  <el-select style="width:100%" v-model="slForm.feeType" placeholder="请选择收款方式"
                             disabled>
                    <el-option v-for="(item,i) in feeTypeEnums" :key="i" :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="projectName">
                  <template #label>项目名称</template>
                  <el-input style="width:100%" v-model="slForm.projectName" placeholder="请输入项目名称"
                            disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" v-if="slForm.lastDetail">
                  <template #label>上阶段收款金额</template>
                  <el-input style="width:100%" disabled type="number"
                            v-model.number="slForm.lastUsedMoney" placeholder="请完善上阶段结算明细">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="applyMoney">
                  <template #label>本次收款金额</template>
                  <el-input style="width:100%" disabled type="number"
                            v-model.number="slForm.applyMoney" placeholder="请完善结算明细">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="supplierName">
                  <template #label>供应商名称</template>
                  <el-input style="width:100%" disabled v-model="slForm.supplierName"
                            placeholder="请输入供应商名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="feeTypeNo">
                  <template #label>金蝶费用类型</template>
                  <el-select style="width:100%" disabled v-model="slForm.feeTypeNo" filterable
                             placeholder="请选择金蝶费用类型">
                    <el-option v-for="item in expenseItem" :key="item.expenseItemID"
                               :label="item.expenseItem" :value="item.expenseItemID">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%">
                  <template #label>金蝶项目编号</template>
                  <el-input disabled style="width:100%" v-model="slForm.projectNo"
                            placeholder="请输入金蝶项目编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="receiptType">
                  <template #label>发票类型</template>
                  <el-select style="width:100%" disabled v-model="slForm.receiptType"
                             placeholder="请选择收款方式">
                    <el-option v-for="(item,i) in receiptTypeEnums" :key="i" :label="item.label"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item style="width:100%" prop="deliveryNum">
                  <template #label>快递单号</template>
                  <el-input style="width:100%" disabled v-model="slForm.deliveryNum"
                            placeholder="邮寄纸质材料快递单号 (若无不填写)"></el-input>
                </el-form-item>
              </el-col>


              <el-col :span="24">
                <el-form-item style="width:100%" prop="meetingIds">
                  <template #label>本次结算会议</template>
                  <el-select style="width:100%" v-model="slForm.meetingIds" placeholder="请选择您要结算的会议"
                             clearable multiple :collapse-tags="false" disabled>
                    <el-option v-for="item in meetingList" :key="item.id" :label="item.meetingTitle"
                               :value="Number(item.id)">
                      {{ item.meetingTitle }} / {{ $moment(item.updateTime).format('lll') }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <el-card class="box-card" style="margin-top: 10px">
          <div v-if="currentDetail" slot="header" class="clearfix" style="display: flex; align-items: center; gap: 12px;">

            <!-- 返回按钮（仅图标） -->
            <el-button size="small" type="text" icon="el-icon-arrow-left" @click="handleBack"/>

            <!-- 标题 -->
            <h2 style="font-size: 20px; margin: 0; font-weight: 600;">
              {{ getProjectLabel(this.currentDetail.spendingProjectCode) }}
            </h2>
            <!-- 右侧操作区 -->
            <div style="margin-left: auto; display: flex; gap: 8px;">
              <el-button type="text" @click="bulkDownload()">一键下载</el-button>
            </div>
          </div>

          <el-collapse class="comMate">


            <!--            这边去掉下面整个div了-->
            <!--            <div class="meetingTheme">-->
            <!--              &lt;!&ndash; <h3 class="annotation"> 明细选择:</h3> &ndash;&gt;-->
            <!--              &lt;!&ndash; 明细选择 &ndash;&gt;-->
            <!--              &lt;!&ndash; <el-select v-model="selectedDetailId" placeholder="请选择明细" @change="handleDetailChange"-->
            <!--                  class="no-border-select detail-select ">-->
            <!--                  <el-option v-for="detail in currentDetails" :key="detail.id"-->
            <!--                      :label="`${getProjectLabel(detail.spendingProjectCode)}（金额：${detail.money}元）`"-->
            <!--                      :value="detail.id" />-->
            <!--              </el-select> &ndash;&gt;-->
            <!--              <el-tabs type="border-card" v-model="selectedDetailId" @tab-click="handleDetailChange"-->
            <!--                       class="detailTab">-->
            <!--                <el-tab-pane :label="`${getProjectLabel(detail.spendingProjectCode)}（金额：${detail.money}元）`"-->
            <!--                             :name="detail.id + ''" v-for="detail in currentDetails" :key="detail.id"></el-tab-pane>-->
            <!--              </el-tabs>-->
            <!--            </div>-->


            <div class="options">
              <!-- <el-button type="primary" size="mini" @click="downloadAll">下载全部文件</el-button> -->
            </div>
            <!-- 合规材料 -->
            <div class="complianceMaterials" v-if="currentDetail">

              <div class="compRow" v-for="(folder,index) in currentDetail.folderNodeList" :key="index">
                <div class="compTit">
                  <h1>{{ folder.folderName }}</h1>
                  <!--                <el-button @click.stop="downloadFolderFun(folder)" type="primary"-->
                  <!--                           icon="el-icon-download">下载</el-button>-->
<!--                  <i class="el-icon-success" v-if="folder.auditStatus == 1 && slForm.status=='OFFICIAL_EXAMINE'"></i>-->
<!--                  <el-button size="mini" plain type="warning"-->
<!--                             v-if="folder.auditStatus == 1&& slForm.status=='OFFICIAL_EXAMINE'"-->
<!--                             @click.stop="annotate(folder)">-->
<!--                    重新标注-->
<!--                  </el-button>-->
                  <!--                  {{folder.auditStatus !== 1}}-->
                  <!--                  {{slForm.status=='OFFICIAL_EXAMINE'}}-->
<!--                  <template v-if="folder.auditStatus !== 1 && slForm.status=='OFFICIAL_EXAMINE'">-->
<!--                    <div class="opt">-->
<!--                      <el-button size="mini" plain type="warning" v-if="folder.auditStatus != 1"-->
<!--                                 @click.stop="annotate(folder)">-->
<!--                        整体标注-->
<!--                      </el-button>-->
<!--                      <el-button v-if="folder.auditStatus != 1" size="mini" plain type="primary"-->
<!--                                 @click.stop="apply(folder)">-->
<!--                        审核通过-->
<!--                      </el-button>-->
<!--                      <i class="el-icon-success" v-else></i>-->
<!--                    </div>-->

<!--                    &lt;!&ndash;                    <i class="el-icon-warning" v-if="folder.examineMessage"></i>&ndash;&gt;-->
<!--                    &lt;!&ndash;                    <br>&ndash;&gt;-->

<!--                    &lt;!&ndash;                    <div class="status">&ndash;&gt;-->
<!--                    &lt;!&ndash;                      <span class="errMsg all" v-if="folder.examineMessage">【整体标注】{{ folder.examineMessage }}</span>&ndash;&gt;-->
<!--                    &lt;!&ndash;                    </div>&ndash;&gt;-->


<!--                    &lt;!&ndash;                  									<div v-for="(log, i) in item.files" :key="i">&ndash;&gt;-->
<!--                    &lt;!&ndash;                  										<span class="" style="color: orangered;"&ndash;&gt;-->
<!--                    &lt;!&ndash;                  											v-if="(log.examineMessage || log.aiExamineMessage) && item.auditStatus !== 1">&ndash;&gt;-->
<!--                    &lt;!&ndash;                  											&lt;!&ndash;											【{{ getShortFileName(log.fileName) }}】&ndash;&gt;&ndash;&gt;-->
<!--                    &lt;!&ndash;                  											{{ log.fileName }}&ndash;&gt;-->
<!--                    &lt;!&ndash;                  											:{{ log.examineMessage || log.aiExamineMessage }}；&ndash;&gt;-->
<!--                    &lt;!&ndash;                  										</span>&ndash;&gt;-->
<!--                    &lt;!&ndash;                  									</div>&ndash;&gt;-->


<!--                  </template>-->
                </div>

                <UploadRequirementExample
                    :project="folder"
                />


                <div class="status" v-if="folder.auditStatus !== 1">
                        <span style="color: darkred;" class="errMsg all"
                              v-if="folder.examineMessage || folder.aiExamineMessage">
                            【整体标注】{{ folder.examineMessage || folder.aiExamineMessage }}
                        </span>

                  <!--                  <template v-for="log in folder.files">-->
                  <!--                            <span class="errMsg one" style="color: orangered;"-->
                  <!--                                  v-if="log.examineMessage || log.aiExamineMessage">-->
                  <!--                                【{{ log.fileName }}】:{{ log.examineMessage || log.aiExamineMessage }}；-->
                  <!--                            </span>-->
                  <!--                  </template>-->
                </div>


                <!-- 使用子组件 -->
                <FileTable
                    :showApplyBtn="slForm.status=='OFFICIAL_EXAMINE'"
                    :file-list="folder.files"
                    :total="folderTotal"
                    :current-page="folderCurrent"
                    :page-size="folderSize"
                    @cell-click="previewFile"
                    @download="downloadFileFun"
                    @annotate="annotateFile"
                    @selection-change="(selection) => handleSelectionChange(selection, folder)"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />


                <!-- 批量操作 -->
                <div style="margin-top: 20px;text-align: right" v-if="slForm.status=='OFFICIAL_EXAMINE'">
                  <el-button type="primary" @click="batchApply" :disabled="folder.selectedFiles.length === 0">
                    一键审核通过
                  </el-button>

                  <el-button type="danger" @click="bulkReject" :disabled="folder.selectedFiles.length === 0">
                    一键审核拒绝
                  </el-button>
                </div>

                <!--                    <div class="compVal">-->
                <!--                        <div class="item" v-for="(file,index1) in folder.files" :key="index1" :title="file.fileName">-->
                <!--                            <div class="FileView">-->
                <!--                                <el-image v-if="isImage(file.ossUrl)" :src="file.ossUrl" fit="cover">-->
                <!--                                    <div slot="error" class="image-slot">-->
                <!--                                        <img :src="require('@/assets/images/i_img.png')" />-->
                <!--                                    </div>-->
                <!--                                </el-image>-->
                <!--                                <el-image v-else-if="isPdf(file.ossUrl)" :src="require('@/assets/images/pdf.png')"-->
                <!--                                    fit="cover"></el-image>-->
                <!--                                <el-image v-else-if="isZip(file.ossUrl)" :src="require('@/assets/images/zip.png')"-->
                <!--                                    fit="cover"></el-image>-->
                <!--                                <el-image v-else-if="isPpt(file.ossUrl)" :src="require('@/assets/images/ppt.png')"-->
                <!--                                    fit="cover"></el-image>-->
                <!--                                <el-image v-else-if="isDoc(file.ossUrl)" :src="require('@/assets/images/doc.png')"-->
                <!--                                    fit="cover"></el-image>-->
                <!--                                <el-image v-else-if="isXls(file.ossUrl)" :src="require('@/assets/images/xls.png')"-->
                <!--                                    fit="cover"></el-image>-->
                <!--                                <el-image v-else :src="require('@/assets/images/i_file.svg')" fit="cover"></el-image>-->
                <!--                            </div>-->

                <!--                            <div class="FileName">-->
                <!--                                {{ file.fileName }}-->
                <!--                            </div>-->


                <!--                            &lt;!&ndash; 审核提示图标 &ndash;&gt;-->
                <!--                            <div v-if="file.examineMessage || file.aiExamineMessage" class="file-warning-icon">-->
                <!--                                <el-tooltip effect="dark" :content="file.examineMessage || file.aiExamineMessage"-->
                <!--                                            placement="top">-->
                <!--                                    <i class="el-icon-warning"></i>-->
                <!--                                </el-tooltip>-->
                <!--                            </div>-->


                <!--                            <div class="viewOpts">-->
                <!--                                <div class="btn view" type="text" @click.stop="previewFile(file,folder.files)">预览</div>-->
                <!--                                &lt;!&ndash;                                <div class="btn label" type="text" @click="rejectAndMark(file)">&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                    标注&ndash;&gt;-->
                <!--                                &lt;!&ndash;                                </div>&ndash;&gt;-->
                <!--                                <div class="btn label" type="text" @click="annotateFile(file)">审核</div>-->

                <!--                                <div class="btn label" type="text" @click="downloadFileFun(file)">下载</div>-->
                <!--                            </div>-->

                <!--                            &lt;!&ndash; 文件错误消息 &ndash;&gt;-->
                <!--                            &lt;!&ndash;                                <div class="file-error" v-if="file.examineMessage">&ndash;&gt;-->
                <!--                            &lt;!&ndash;                                    <span class="errMsg">{{ file.examineMessage }}</span>&ndash;&gt;-->
                <!--                            &lt;!&ndash;                                </div>&ndash;&gt;-->
                <!--                        </div>-->

                <!--                        <div class="noFile" v-if="!folder.files.length">-->
                <!--                            <i class="el-icon-folder-delete"></i>-->
                <!--                            没有文件-->
                <!--                        </div>-->
                <!--                    </div>-->
              </div>

            </div>


          </el-collapse>


        </el-card>


      </el-main>
    </el-container>

    <!--    <div class="formOptions" v-if="slForm.status=='OFFICIAL_EXAMINE'">-->
    <!--      <el-button type="primary" @click="openAuditDialog('SUCCESS')">审核通过</el-button>-->
    <!--      <el-button type="danger" @click="openAuditDialog('ERROR')">审核退回</el-button>-->
    <!--    </div>-->


    <!-- PDF等文件预览弹窗 -->
    <file-preview ref="childPreview" :visible.sync="showPreview" :url="previewUrl" :options="files" @closeNum="getNum"/>

    <!-- 文件标注弹窗 -->
    <el-dialog custom-class="annotationDialog" :title="'审核文件 - ' + currentFileToAnnotate.fileName"
               :close-on-click-modal="false" :visible.sync="fileAnnotateDialogVisible">


      <!-- 右上角按钮：查看历史审核记录 -->
      <div style="text-align: right; ">
        <el-button type="text" @click="handleViewHistory">
          查看历史审核记录
        </el-button>
      </div>


      <!-- 审核操作选择：通过 or 驳回 -->
      <el-radio-group v-model="annotationStatus" style="margin-bottom: 15px;">
        <el-radio :label="1">初审通过</el-radio>
        <el-radio :label="2">初审驳回</el-radio>
      </el-radio-group>

      <!-- 驳回原因输入框（仅当选择“驳回”时显示） -->
      <el-input type="textarea" :rows="4"
                :placeholder="annotationStatus === 2 ? '请输入文件驳回原因' : '请输入备注（选填）'"
                v-model="fileAnnotationText"
                maxlength="300" show-word-limit></el-input>


      <span slot="footer" class="dialog-footer">
				<el-button @click="fileAnnotateDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveFileAnnotation">保存</el-button>
			</span>
    </el-dialog>

    <!-- 标注弹窗 -->
    <el-dialog custom-class="annotationDialog" :title="'审核 - ' + currentAnnotateMaterial.folderName"
               :visible.sync="annotateDialogVisible" width="60%">
      <el-input type="textarea" :rows="4" placeholder="请输入标注内容" v-model="annotationText"></el-input>
      <span slot="footer" class="dialog-footer">
				<el-button @click="annotateDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveAnnotation">保存标注</el-button>
			</span>
    </el-dialog>

    <!-- 通用审核弹窗 -->
    <el-dialog custom-class="reviewDialog" :title="this.dialogType === 'SUCCESS' ? '审核通过确认' : '审核退回'"
               :visible.sync="auditDialogVisible" width="500px" append-to-body>
      <div class="form">
        <h2 v-if="dialogType != 'ERROR'">提交事由：</h2>
        <div v-if="dialogType != 'ERROR'" class="tips">提交事由将会在金蝶中的事由字段中做展示</div>
        <el-form :model="auditForm" ref="auditForm" :rules="auditRules">
          <!-- 动态显示不同字段 -->
          <el-form-item v-if="dialogType === 'SUCCESS'" label="审核备注" prop="remark">
            <el-input maxlength="100" show-word-limit type="textarea" :rows="4" placeholder="请输入审核备注"
                      v-model="auditForm.remark"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogType === 'ERROR'" label="退回原因" prop="errorMessage">
            <el-input maxlength="100" show-word-limit type="textarea" :rows="4" placeholder="请输入退回原因"
                      v-model="auditForm.errorMessage"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="auditDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmAudit">确 定</el-button>
			</span>
    </el-dialog>


    <!-- 弹窗组件 -->
    <HistoryReviewDialog v-if="this.currentFileToAnnotate.id" v-model="showHistoryDialog"
                         :file-id="this.currentFileToAnnotate.id"/>

  </div>
</template>

<script>
import {
  allSpendFolderListOfOfficial,
  annotateFile,
  annotateFolder,
  batchAuditPass,
  batchAuditReject,
  downloadDetailFolderBYOfficial,
  examineSpendingOrder,
  getFilesWithOffcial,
  getOrderByIdWithOfficial,
  getOrderMeetingListByOrderId,
  listOrderLog,
  officialGetExpenseItem,
  queryFile
} from '@/request/api'
import FilePreview from '@/components/FilePreview.vue';
import HistoryReviewDialog from '@/components/HistoryReviewDialog.vue';
import UploadRequirementExample from "@/components/UploadRequirementExample/UploadRequirementExample.vue";

import FileTable from '@/components/FileTable/FileTable.vue';

export default {
  name: 'viewDetail',
  components: {
    FileTable,
    FilePreview,
    HistoryReviewDialog,
    UploadRequirementExample
  },

  computed: {

    selectFolderId() {
      return this.$route.query.selectFolderId;
    },
    // 获取会议列表（等价于你原来的 folderList）
    folderListData() {
      return this.folderList || [];
    },
    // 当前会议下的明细列表
    currentDetails() {
      // if (!this.selectedMeetingId) return [];
      console.log("folderListData", this.folderListData)
      // const meeting = this.folderListData.find(m => m.meetingId === this.selectedMeetingId);
      // return meeting ? meeting.details : [];
      return this.folderListData.length != 0 ? this.folderListData[0].details : [];


    }
  },
  data() {
    return {
      folderCurrent: 1,
      folderTotal: 0,
      folderSize: 20,
      checkRow: '',

      num: -1,
      showHistoryDialog: false, //展示文件历史审核日志
      selectedMeetingId: null, // 当前选中的会议 ID
      selectedDetailId: null, // 当前选中的明细 ID
      currentDetail: null, // 当前选中的明细对象

      loading: false,
      //审核日志
      logList: [],
      expenseItem: [],
      slForm: {
        collectWay: '', // 收款方式
        feeType: '', // 费用类型
        projectName: '', // 项目名称
        supplierName: '', // 供应商名称
        applyMoney: 0, // 本次收款金额
        receiptType: '', // 发票类型
        deliveryNum: '', // 快递单号
        feeTypeNo: '',
        projectNo: ''
      },
      feeTypeEnums: [{
        value: "0",
        label: "会议类"
      },
        {
          value: '1',
          label: "非会议类"
        }
      ],
      receiptTypeEnums: [{
        value: "0",
        label: "电子发票"
      }, {
        value: "1",
        label: "纸质发票"
      },
        {
          value: "2",
          label: "电子+纸质发票"
        }
      ],

      collectWayList: {
        "0": "一次性收款并结项",
        "1": "首次收款",
        "2": "阶段收款",
        "3": "尾款",
        "4": "据实结算",
      },

      collectWayEnums: [{
        value: "0",
        label: "一次性收款并结项"
      }, {
        value: "1",
        label: "首次收款"
      }, {
        value: "2",
        label: "阶段收款"
      }, {
        value: "3",
        label: "尾款"
      }, {
        value: "4",
        label: "据实结算"
      }],
      auditForm: {
        remark: '', // 审核通过备注
        errorMessage: '' // 审核退回原因
      },
      auditDialogVisible: false, // 控制弹窗显示
      dialogType: '', // 操作类型：SUCCESS/ERROR
      // 表单验证规则
      auditRules: {
        remark: [{
          required: true,
          message: '请输入备注',
          trigger: 'blur'
        },
          {
            min: 5,
            message: '备注不能少于5个字符',
            trigger: 'blur'
          }
        ],
        errorMessage: [{
          required: true,
          message: '请输入退回原因',
          trigger: 'blur'
        },
          {
            min: 5,
            message: '原因不能少于5个字符',
            trigger: 'blur'
          }
        ]
      },
      projectTree: [],
      meetingList: [],
      hoveredFile: null, // 当前悬停的文件
      folderList: [],
      // materials: folderData.children,
      showPreview: false,
      previewUrl: '',
      isPdfPreview: false,
      isImagePreview: false,
      currentFile: null,
      files: [],
      annotationStatus: 2,
      currentFileToAnnotate: {
        fileName: ''
      }, // 要标注的文件
      annotateDialogVisible: false,
      fileAnnotateDialogVisible: false, // 文件标注弹窗
      annotationText: '',
      fileAnnotationText: '', // 文件标注内容
      currentAnnotateMaterial: {
        folderName: ''
      },
      rules: {
        collectWay: [{
          required: true,
          message: '请选择收款方式',
          trigger: 'change'
        }],
        feeType: [{
          required: true,
          message: '请选择费用类型',
          trigger: 'change'
        }],
        projectName: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'change'
        }],
        supplierName: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'change'
        }],
        applyMoney: [{
          required: true,
          message: '请完善本次收款明细',
          trigger: 'change'
        }],
        lastUsedMoney: [{
          required: true,
          message: '请完善上阶段支出明细',
          trigger: 'change'
        }],
        receiptType: [{
          required: true,
          message: '请选择发票类型',
          trigger: 'change'
        }],
        deliveryNum: [{
          required: false,
          message: '请输入快递单号',
          trigger: 'blur'
        }],
        // meetingIds: [{
        //   required: true,
        //   message: '请选择您要结算的会议场次',
        //   trigger: 'change'
        // }],
        projectNo: [{
          required: true,
          message: '请输入金蝶项目编号',
          trigger: 'change'
        }],
        feeTypeNo: [{
          required: true,
          message: '请选择金蝶项目类型',
          trigger: 'change'
        }]
      },
    }
  },
  created() {
    this.orderId = this.$route.query.orderId
    // this.selectedMeetingId = Number(this.$route.query.selectedMeetingId) // 当前选中的会议 ID
    this.selectedDetailId = this.$route.query.selectedDetailId.toString() // 当前选中的明细 ID


    this.getSheetDataFun();
    this.getProjectConfigFun();
    this.getExpenseItemFun();
    this.loadData();
    // this.loadLog();
  },
  methods: {
    handleSelectionChange(selection, folder) {
      // 将选中的文件保存到当前 folder
      folder.selectedFiles = selection;
    },


    handleSizeChange(val) {
      this.folderSize = val
      let data = {
        id: this.checkRow.id,
        size: this.folderSize,
        current: this.folderCurrent
      }
      this.getDetailFolderAndFilesFun(data)
    },

    handleCurrentChange(val) {
      this.folderCurrent = val
      let data = {
        id: this.checkRow.id,
        size: this.folderSize,
        current: this.folderCurrent
      }
      this.getDetailFolderAndFilesFun(data)
    },

    // 批量通过：遍历所有 folder，对其 selectedFiles 执行审核
    batchApply() {
      const hasSelected = this.currentDetail.folderNodeList.some(
          folder => folder.selectedFiles && folder.selectedFiles.length > 0
      );

      if (!hasSelected) {
        this.$message.warning('请先选择需要审核通过的文件');
        return;
      }

      this.$confirm('确认批量审核通过选中的文件吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.currentDetail.folderNodeList.forEach(folder => {
          const selected = folder.selectedFiles;
          if (selected && selected.length > 0) {
            this.applyFiles(selected, folder);
          }
        });
      }).catch(() => {
        this.$message.info('已取消批量审核');
      });
    },
    // 批量拒绝
    bulkReject() {
      const hasSelected = this.currentDetail.folderNodeList.some(
          folder => folder.selectedFiles && folder.selectedFiles.length > 0
      );

      if (!hasSelected) {
        this.$message.warning('请先选择需要拒绝的文件');
        return;
      }

      this.$prompt('请输入拒绝原因（可选）', '批量拒绝', {
        type: 'warning',
        inputPlaceholder: '请输入拒绝原因',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({value}) => {
        this.currentDetail.folderNodeList.forEach(folder => {
          const selected = folder.selectedFiles;
          if (selected && selected.length > 0) {
            this.rejectFiles(selected, folder, value); // value 可能为空
          }
        });
      }).catch(() => {
        this.$message.info('已取消批量拒绝');
      });
    },

// ✅ 执行审核通过逻辑
    applyFiles(fileList, folder) {
      const fileIds = fileList.map(file => file.id);
      console.log(fileIds)

      // 调用后端接口（假设接口存在）
      batchAuditPass(fileIds).then(res => {
        if (res.success || res.code === 200) {
          // ✅ 成功：清空当前 folder 的选中项
          folder.selectedFiles = [];

          // 可选：更新文件状态
          // fileList.forEach(file => {
          //     file.auditStatus = 1; // 假设 1 表示已审核
          // });

          // // 可选：更新文件夹整体状态
          // this.updateFolderAuditStatus(folder);
          this.loadData();

          this.$message.success(`【${folder.folderName}】中的 ${fileList.length} 个文件审核通过`);
        } else {
          this.$message.error(`【${folder.folderName}】审核失败：${res.message || '未知错误'}`);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error(`【${folder.folderName}】审核请求失败`);
      });
    },
    // ✅ 执行拒绝逻辑
    rejectFiles(fileList, folder, reason) {
      const fileIds = fileList.map(file => file.id);

      // 调用后端拒绝接口
      batchAuditReject(fileIds, reason).then(res => {
        if (res.success || res.code === 200) {
          // ✅ 成功：清空选中
          folder.selectedFiles = [];

          // 可选：更新文件状态
          // fileList.forEach(file => {
          //     file.auditStatus = 2; // 假设 2 表示已拒绝
          //     file.rejectReason = reason;
          // });
          this.loadData();
          // this.updateFolderAuditStatus(folder);

          this.$message.success(`【${folder.folderName}】中的 ${fileList.length} 个文件已拒绝`);
        } else {
          this.$message.error(`【${folder.folderName}】拒绝失败：${res.message || '未知错误'}`);
        }
      }).catch(err => {
        console.error(err);
        this.$message.error(`【${folder.folderName}】拒绝请求失败`);
      });
    },


    getDetailFolderAndFilesFun(data) {
      getFilesWithOffcial(data).then(res => {
        // this.folderShow = true
        // this.FolderRow = res.data.records.map(item => {
        //   if (item.examineMessage) {
        //     item.examineMessage = item
        //         .examineMessage.split(';')
        //   }
        //   return item
        // })
        this.folderTotal = res.data.total
        this.$nextTick()
        // console.log(JSON.parse(JSON.stringify(this.FolderRow)));
      })
    },

    handleIndexPage() {
      sessionStorage.setItem("pageNum", -1);
      this.$router.push(`/fileListPreviewnew?orderId=${this.$route.query.orderId}`)
    },
    handleBack() {
      this.num = sessionStorage.getItem("pageNum");
      if(this.num==null || this.num==undefined){
        console.log("执行3")
        this.$router.go(-1)
        return;
      }
      if (this.num != -1) {
        this.$router.go(this.num)
        sessionStorage.setItem("pageNum", -1);
        return;
      }
      this.$router.go(-1)
    },

    getNum(num) {
      console.log("得到" + num)
      this.num = num
    },
    handleViewHistory() {
      this.showHistoryDialog = true
    },

    // 获取项目名称
    getProjectLabel(code) {
      const project = this.projectTree.find(p => p.id == code);
      return project ? project.projectType : '未知项目';
    },

    // 会议选择变化
    handleMeetingChange() {
      this.selectedDetailId = null;
      this.currentDetail = null;
    },


    // 批量下载
    async bulkDownload() {
      try {
        await this.$confirm('是否下载当前明细下全部文件？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.loading = true;
        this.$message({
          message: '正在下载，请稍后...',
          type: 'warning'
        });
        downloadDetailFolderBYOfficial({
          detailId: this.currentDetail.id
        }).then(res => {
          const projectName = this.getProjectLabel(this.currentDetail.spendingProjectCode);
          const filename = `${projectName}.zip`;
          let blob = new Blob([res], {
            type: 'application/zip'
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.target = '_blank';
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        })
      } catch (error) {
        //  关键：只处理非“取消”的错误
        if (error !== 'cancel') {
          this.$message.error('操作失败，请稍后重试');
          console.error('Download error:', error);
        }
        // 如果是 'cancel'，静默忽略，不报错
      }

    },

    // 明细选择变化
    handleDetailChange() {
      if (!this.selectedDetailId) return;

      var currentDetail = []

      currentDetail = this.currentDetails.find(d => d.id === this.selectedDetailId);
      currentDetail.folderNodeList.forEach(folder => {
        this.$set(folder, 'selectedFiles', []); // 确保响应式
      });
      console.log(" this.currentDetail", currentDetail)
      console.log("selectFolderId", this.selectFolderId);

      // 假设 currentDetail 是从某处拿到的对象
      const id = this.selectFolderId;

      let newFolderNodeList = currentDetail.folderNodeList;

      if (id) {
        newFolderNodeList = currentDetail.folderNodeList.filter(folder =>
            String(folder.id) === String(id)
        );
      }

// 创建一个新的 currentDetail 对象（关键！）
      this.currentDetail = {
        ...currentDetail,
        folderNodeList: newFolderNodeList
      };


    },

    //查询审核日志
    loadLog() {
      listOrderLog({
        orderId: this.$route.query.orderId
      }).then(res => {
        if (res.code == 200) {
          this.logList = res.data;
        }
      })
    },
    formatStatus(item) {
      const status = item.status
      const statusMap = {
        OFFICIAL_EXAMINE: '待审核',
        SUBMIT: '初审通过',
        ERROR: '初审驳回',
        SUCCESS: '初审通过'
      };
      if (item.operatorId == '0' && status == 'ERROR') {
        return "复审驳回"
      }
      return statusMap[status] || '未知状态';
    },
    // 确认审核操作
    confirmAudit() {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.examineSpendingOrder();
          this.auditDialogVisible = false;
        }
      });
    },
    examineSpendingOrder() {
      console.log('备注：', this.auditForm.remark);
      console.log('审核退回，原因：', this.auditForm.errorMessage);
      this.loadingText = '正在提交···'
      this.loading = true;
      examineSpendingOrder({
        orderId: this.slForm.id,
        status: this.dialogType,
        remark: this.auditForm.remark,
        errorMessage: this.auditForm.errorMessage
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getSheetDataFun();
          this.loadLog()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    },
    getExpenseItemFun(itemName) {
      let data = {}
      data.current = 1;
      data.size = 3000;
      if (itemName) data.itemName = itemName
      officialGetExpenseItem(data).then(res => {
        if (res.code == 200) {
          this.expenseItem = res.data.data
        }
      })
    },

    // 获取结算单信息
    getSheetDataFun() {
      getOrderByIdWithOfficial({
        orderId: this.$route.query.orderId
      }).then(res => {
        if (res.code == 200) {
          let resData = JSON.parse(JSON.stringify(res.data));
          for (let i in resData) {
            if (resData[i] == null) resData[i] = '';
          }
          ;
          if (resData.collectWay == 2 || resData.collectWay == 3) {
            resData.lastDetail = [];
            // resData.lastUsedMoney = '';
            let array = []
            resData.spendingDetailDtos.map((item, i) => {
              if (item.detailType == "L") {
                resData.lastDetail.push(item);
              } else {
                array.push(item);
              }
            });
            resData.spendingDetailDtos = array;
          }
          if (resData.meetingIds) {
            // resData.meetingIds
            console.log(resData.meetingIds);
          } else {
            resData.meetingIds = [];
          }
          ;
          // console.log(resData);
          this.slForm = resData;
          this.meetingList = resData.meetingList || [];


          // this.$forceUpdate()
          this.getMeetingList();
        }
        ;
      });
    },
    // 获取会议列表
    getMeetingList() {

      // orderMeetingListBOfficial(data).then(res => {
      //   if (res.code == 200) this.meetingList = res.data;
      // });
      getOrderMeetingListByOrderId({
        orderId: this.orderId
      }).then(res => {
        if (res.code == 200) {
          this.meetingList = res.data;
        }
      });
    },
    // 获取支出明细类型列表
    getProjectConfigFun() {
      allSpendFolderListOfOfficial().then(res => {
        if (res.code == 200) {
          this.projectTree = res.data
        }
      })
    },
    loadData() {
      queryFile({
        id: this.$route.query.orderId
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.folderList = res.data;
          console.log("folderList", this.folderList);
          // 关键点：重新加载当前选中的明细，触发视图刷新
          this.handleDetailChange();

        }
      })
    },
    // 打开审核弹窗
    openAuditDialog(type) {
      this.dialogType = type;
      this.auditDialogVisible = true;
      this.resetForm();
      if (type === 'SUCCESS') {
        this.auditForm.remark =
            `【会议合规管理】-供应商结算-${this.slForm.projectName}-${this.collectWayList[this.slForm.collectWay]}`;
      }
    },
    // 重置表单
    resetForm() {
      this.auditForm = {
        remark: '',
        errorMessage: ''
      };
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields();
      }
    },
    // 打开文件标注对话框
    annotateFile(file) {
      this.currentFileToAnnotate = file;
      this.fileAnnotationText = file.examineMessage || '';
      this.fileAnnotateDialogVisible = true;
    },

    // 下载文件
    downloadFileFun(row) {
      console.log(row)
      if (this.isZipFile(row.fileName)) {
        // if (row.type == "FOLDER") {
        this.loadingText = '正在下载文件夹';
        this.loading = true;
        this.download('/signLive/order/downloadFolderById', {
          folderId: row.id
        }, row.folderName`_${new Date().getTime()}.zip`)
      } else {
        this.loadingText = '正在下载文件';
        this.loading = true;

        setTimeout(() => {
          this.loading = false;
          const x = new XMLHttpRequest();
          x.open("GET", row.ossUrl, true);
          x.responseType = 'blob';
          x.onload = function (e) {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.download = row.fileName;
            a.click();
            a.remove();
          };
          x.send();
        }, 1000);
      }
      ;
    },

    // 判断是否是压缩文件
    isZipFile(filename) {
      const ext = filename.toLowerCase().split('.').pop();
      return ['zip', 'rar', 'tar', 'gz', '7z'].includes(ext);
    },

    // 判断文件是否为PDF
    isPdf(fileName) {
      return fileName.toLowerCase().endsWith('.pdf');
    },
    // 判断文件是否为图片
    isImage(fileName) {
      const imgExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      return imgExts.some(ext => fileName.toLowerCase().endsWith(ext));
    },
    isWord(filename) {
      return /\.(doc|docx)$/i.test(filename);
    },
    isExcel(filename) {
      return /\.(xls|xlsx)$/i.test(filename);
    },
    isPPT(filename) {
      return /\.(ppt|pptx)$/i.test(filename);
    },
    // 获取短文件名（防止文件名过长）
    getShortFileName(fileName) {
      if (fileName.length > 15) {
        return fileName.substring(0, 8) + '...' + fileName.slice(-7);
      }
      return fileName;
    },
    // 预览单个文件
    previewFile(file, files) {
      console.log(file)

      this.files = files.map(file => ({
        url: file.ossUrl,
        fileName: file.fileName
      }));
      this.currentFile = file;
      this.previewUrl = file.ossUrl;
      this.showPreview = true;
      this.$refs.childPreview.openModal()
    },
    // 预览整个文件夹
    previewFiles(material) {
      if (material.files.length > 0) {
        this.previewFile(material.files[0]);
      } else {
        this.$message.warning('此材料项下暂无文件可预览');
      }
    },
    // 关闭预览
    closePreview() {
      this.showPreview = false;
      this.previewUrl = '';
    },
    // 下载文件
    downloadFile() {
      if (this.currentFile) {
        window.open(this.currentFile.ossUrl, '_blank');
      }
    },
    // 打开标注对话框
    annotate(material) {
      this.currentAnnotateMaterial = material;
      this.annotationText = ''; // 清空之前的标注
      this.annotationStatus = 2
      this.annotateDialogVisible = true;
    },
    //文件夹审核通过
    apply(material) {
      //文件夹整体审核通过
      annotateFolder({
        folderId: material.id,
        auditStatus: 1 //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('标注已保存');
          this.loadData()
        }
      })
    },
    // 保存标注
    saveAnnotation() {
      if (!this.annotationText.trim()) {
        this.$message.warning('请先输入标注内容');
        return;
      }
      annotateFolder({
        folderId: this.currentAnnotateMaterial.id,
        annotation: this.annotationText,
        auditStatus: 2 //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('标注已保存');
          this.annotateDialogVisible = false;
          this.loadData()
        }
      })
    },
    // 保存文件标注
    saveFileAnnotation() {


      // 只有在“驳回”时才需要校验必须填写原因
      if (this.annotationStatus == 2) { // 假设 2 表示“驳回”
        if (!this.fileAnnotationText.trim()) {
          this.$message.warning('请填写文件驳回原因');
          return;
        }
      }

      annotateFile({
        orderId: this.orderId,
        fileId: this.currentFileToAnnotate.id,
        annotation: this.fileAnnotationText,
        auditStatus: this.annotationStatus //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('文件标注已保存');
          this.fileAnnotateDialogVisible = false;
          this.loadData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 模拟上传文件
    uploadFile(material) {
      this.$message.info('文件上传功能已触发，实际项目中调用上传API');
    },
    // 显示详情
    showMaterialDetails(material) {
      this.$message({
        message: `${material.folderName} 的详细信息`,
        customClass: 'custom-message',
        duration: 2000,
        iconClass: 'el-icon-info'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #f5f7fa;
}

//.app-container {
//  //max-width: 1200px;
//  margin: 20px auto;
//  padding: 0 20px;
//}


.material-list {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  overflow: hidden;
}

.material-item {
  border-bottom: 1px solid #eaeef5;
  padding: 20px;
  transition: background-color .3s;
}

.material-item:last-child {
  border-bottom: none;
}

.material-item:hover {
  background-color: #f9fbfd;
}

.material-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.material-title {
  font-weight: 500;
  font-size: 16px;
  color: #1f2d3d;
}

.material-status {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-badge {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 12px;
  background-color: #ecf5ff;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}

.status-badge.orange {
  background-color: #fdf6ec;
  color: #e6a23c;
  border-color: #faecd8;
}

.status-badge.red {
  background-color: #fdf6ec;
  color: red;
  border-color: #faecd8;
}

.file-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.file-item {
  position: relative;
  width: 100px;
  //height: 100px;
  //border: 1px dashed #dcdfe6;
  //border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  cursor: pointer;
  transition: border-color .3s;

  .file-preview {
    position: relative;
    background-color: #fff;
    width: 100%;
    width: 100%;
    //height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;

    .file-icon {
      width: 100px;
      height: 100px;
      object-fit: contain;
      /* 可选：保持图片比例 */
    }
  }
}

.file-item:hover {
  border-color: #409eff;
}

//.file-preview {
//  width: 60px;
//  height: 60px;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  font-size: 40px;
//  color: #909399;
//}


/* 文件右上角提示符号 */
.file-warning-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  // width: 20px;
  // height: 20px;
  // background: #E6A23C;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  i {
    font-size: 17px;
    font-weight: bold;
    color: #E6A23C;
  }
}

/* 文件悬浮遮罩层 */
.file-hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 1;

  .mask-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .mask-button {
    margin: 4px 0;
    width: 80px;
    background: rgba(255, 255, 255, 0.8);
    border: none;

    &:hover {
      background: white;
    }
  }
}

.file-name {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #606266;
  width: 100%;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  //-webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.action-panel {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 10px;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  height: 100%;
}

.upload-placeholder i {
  font-size: 28px;
  margin-bottom: 5px;
}

.icon-pdf {
  color: #f56c6c;
}

.icon-image {
  color: #67c23a;
}

.icon-other {
  color: #909399;
}

.pdf-viewer-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-viewer {
  width: 80%;
  height: 90%;
}

.close-preview {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  color: white;
  cursor: pointer;
}

.formOptions {
  margin: 20px;
  display: flex;
  justify-content: center;
}

.noFile {
  width: 100px;
  height: 80px;
  //margin: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 10px;
  padding: 10px;
  color: #ccc;
  font-size: 16px;
  margin-bottom: 10px;

  i {
    font-size: 30px;
  }
}

.auditLog {
  margin: 40px;
  padding: 40px;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 4px;

  h1 {
    margin-bottom: 20px;
    font-size: 20px;
  }
}

.basicInformation {
  padding: 20px;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 4px;

  h1 {
    margin-bottom: 20px;
    font-size: 20px;
  }
}

::v-deep .slForm {

  .el-form-item {
    display: flex;
    flex-direction: row;

    .el-form-item__label {
      width: 120px;
      text-align: right;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
    }

  }
}

.reviewfileList {
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  padding: 40px;
  margin-bottom: 40px;

  .page-title {
    margin: 0 0 20px;
    color: #1f2d3d;
    font-weight: 500;
    font-size: 22px;
    //border-bottom: 1px solid #e6ebf5;
    display: flex;
    align-items: center;
  }

  .page-title i {
    margin-right: 10px;
    font-size: 24px;
    color: #409EFF;
  }

}

.review-container {
  .viewOpts {
    display: flex;
    padding: 10px 0;
    align-items: center;

    .meeting-select,
    .detail-select {
      display: flex;
      align-items: center;
      margin-right: 20px;

      p {
        width: auto;
      }
    }

    .back {
      margin-right: 20px;
    }
  }
}


//新的
::v-deep .comMate {

  .meetingTheme {
    display: flex;
    align-items: center;
    // border-bottom: 1px solid #ccc;
    margin-bottom: 10px;

    h2,
    h3 {
      width: 13%;
      margin: 0 20px 0 0;
    }

    .el-select {
      flex: 1;
      // border: 1px solid #666;
    }

    .el-button {
      margin-right: 20px;
    }

    .el-tabs {
      flex: 1;
      max-width: 100%;
      box-sizing: border-box;

      * {
        box-sizing: border-box;
      }

      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__content {
        display: none;
      }
    }

    .meetingTab {
      .el-tabs__item {
        font-size: 20px;
      }
    }
  }


  .complianceMaterials {
    display: flex;
    flex-direction: column;

    .noFile {
      width: 100px;
      height: 80px;
      margin: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
      border-radius: 10px;
      padding: 10px;
      color: #ccc;
      font-size: 16px;
      margin-bottom: 10px;

      i {
        font-size: 30px;
      }
    }

    .compRow {
      display: flex;
      flex-direction: column;
      box-shadow: 0 2px 18px rgba(203, 203, 203, 0.31);
      border-radius: 10px;
      margin-bottom: 20px;
      padding: 20px;

      h1 {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin: 0;
      }

      h2 {
        font-size: 14px;
        color: #666;
        font-weight: bold;
        margin: 0;
      }

      .compTit {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 10px;


        .el-button {
          padding: 2px 3px;
          margin-left: 10px;

          &:first-child {
            margin-left: 0;
          }
        }

        .el-icon-warning {
          font-size: 14px;
          margin-left: 10px;
          color: #F56C6C;
        }

        .el-icon-success {
          font-size: 14px;
          margin-left: 10px;
          color: #67C23A;
        }

        .errMsg {
          font-size: 12px;
          margin-right: 5px;
          color: orangered;
          font-weight: bold;
        }

        .errMsg.all {
          font-size: 12px;
          color: darkred;
          font-weight: bold;
        }

        .opt {
          margin-left: 10px;
          display: flex;
          align-items: center;
        }

        label {
          font-size: 12px;
          color: #999
        }
      }

      .status {
        width: 100%;
        margin-bottom: 5px;

        .errMsg {
          display: block;
          font-size: 14px;
          margin-bottom: 4px;
        }
      }

      .compVal {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        width: 100%;

        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 5px;
          margin: 5px;
          width: 130px;
          //cursor: pointer;
          position: relative;

          //* {
          //    cursor: pointer;
          //    transition: all .3s;
          //}

          &:hover {
            .FileName {
              color: #409EFF;
            }

            .FileView .el-image {
              box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2);
            }

            .viewOpts {
              // display: flex;
              opacity: 1;
            }
          }
        }

        .FileView {
          width: 100px;
          height: 100px;
          display: flex;

          .el-image {
            width: 100%;
            height: 100%;
            border-radius: 20px;
            box-shadow: 0 2px 18px rgba(203, 203, 203, 0.31);
          }
        }

        .FileName {
          padding-top: 5px;
          font-size: 13px;
          color: #555;
          word-break: break-all;
          font-weight: bold;
          overflow: hidden;
          /*内容超出后隐藏*/
          text-overflow: ellipsis;
          /*超出内容显示为省略号*/
          display: -webkit-box;
          /*将对象作为弹性伸缩盒子模型显示*/
          -webkit-box-orient: vertical;
          /*从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）*/
          //-webkit-line-clamp: 2;
          /*这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。可根据需要设置超出多少行后显示省略号*/
        }

      }

      .compFile7 {
        // padding-left: 16px;

        .item {
          margin-bottom: 10px;

          &:last-child {
            margin: 0;
          }
        }

        .fileRow {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          width: 100%;

          .fileItem {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px;
            margin: 5px;
            width: 130px;
            //cursor: pointer;
            position: relative;

            //* {
            //    cursor: pointer;
            //    transition: all .3s;
            //}

            &:hover {
              .FileName {
                color: #409EFF;
              }

              .FileView .el-image {
                box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2);
              }

              .viewOpts {
                // display: flex;
                opacity: 1;
              }
            }
          }

          .FileView {
            width: 100px;
            height: 100px;
            display: flex;

            .el-image {
              width: 100%;
              height: 100%;
              border-radius: 20px;
              box-shadow: 0 2px 18px rgba(203, 203, 203, 0.31);
            }
          }

          .FileName {
            padding-top: 5px;
            font-size: 13px;
            color: #555;
            font-weight: bold;
            overflow: hidden;
            word-break: break-all;
            /*内容超出后隐藏*/
            text-overflow: ellipsis;
            /*超出内容显示为省略号*/
            display: -webkit-box;
            /*将对象作为弹性伸缩盒子模型显示*/
            -webkit-box-orient: vertical;
            /*从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）*/
            -webkit-line-clamp: 2;
            /*这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。可根据需要设置超出多少行后显示省略号*/
          }


        }
      }

      .viewOpts {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(90, 90, 90, 0.5);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 25px 10px;
        opacity: 0;

        .btn {
          width: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          font-weight: bold;
          text-shadow: 0 0 5px #000;
          //cursor: pointer;
          transition: all .3s;

          &:hover {
            text-shadow: 0 0 20px #000;
            font-size: 18px;
          }
        }
      }

    }
  }


  .null {
    background-color: #fff;
    text-align: center;
    font-size: 16px;
    color: #999;
    box-shadow: 0px 2px 13px rgba(203, 203, 203, .3);
    padding: 30px;
    border-radius: 10px;
  }

  .opts {
    display: flex;
    margin-top: 20px;
    align-items: center;
    justify-content: center;

    .el-button {
      height: 50px;
      font-size: 16px;
      font-weight: bold;
    }
  }

  .option {
    margin-bottom: 10px;

  }
}

::v-deep .el-table {

  .cell {
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}


</style>
